import React, { PureComponent, Fragment } from 'react';
import thirdPartyScripts from './thirdPartyScripts';
import { withRouter } from 'react-router';
import common from 'ui-react-common';

const isProd = common.util.env.isProd;
/**
 * Renders third party scripts for production build.
 * Google Analytics is built into the React Router history event.
 *
 */
export class ProdConfig extends PureComponent {
    componentDidMount() {
        if (isProd()) {
            thirdPartyScripts.initializeGoogleTagManager();
            thirdPartyScripts.initializeFullStory();
        }
    }


    render() {
        return isProd() ? <Fragment /> : null;
    }
}


export default withRouter(ProdConfig);
